import { GroupStatusEvent, PinnedMessage, PServed, useIM } from '@wui/im'
import { defineStore } from 'pinia'
import { ref } from 'vue'

import { pServedIsRoom } from '@/shared/utils/uri'

export const usePinEventsStore = defineStore('pin-events', () => {
  const { onConferenceUpdated } = useIM()

  const pinEventsByPServed = ref(new Map<PServed, PinnedMessage[]>())

  const getPinEventsForRoom = (pServed: PServed) => {
    return pinEventsByPServed.value.get(pServed)
  }

  const setPinnedMessages = (pServed: PServed, messages: PinnedMessage[]) => {
    pinEventsByPServed.value.set(pServed, messages)
  }

  const removePinnedMessage = (pServed: PServed, eventId: number) => {
    const current = getPinEventsForRoom(pServed) ?? []
    setPinnedMessages(pServed, current.filter((event) => event.eventId !== eventId))
  }

  const clearPinnedMessages = (pServed: PServed) => {
    setPinnedMessages(pServed, [])
  }

  onConferenceUpdated((event: GroupStatusEvent) => {
    if (pServedIsRoom(event.pServed) && event.extendedParams.isEnabled === false) {
      return
    }
    const pins = event.extendedParams.pinnedMessages
      ? event.extendedParams.pinnedMessages.map((message) => ({
        ...message,
        extendedParams: {
          ...message.extendedParams,
          ...(message.extendedParams.files
            ? { files: message.extendedParams.files.map((file) => ({ ...file })) }
            : {}),
        },
      }))
      : []
    setPinnedMessages(event.pServed, pins)
  })

  return {
    pinEvents: pinEventsByPServed,
    getPinEventsForRoom,
    setPinnedMessages,
    removePinnedMessage,
    clearPinnedMessages,
  }
})
